import { ChainId } from '../../types/mod';

export const TRADE_LOADING_HINT = {
    [ChainId.ZkSyncEra]: '50%-90% estimated gas will be refunded automatically !',
} as any;
